import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconScreenCapture: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconScreenCapture"><Path d="M2.5 6.5V4.5H4.5M13.5 4.5H16.5M7.5 4.5H10.5M19.3889 4.5H21.5V6.5M10.5 19.5H7.5M4.5 19.5H2.5V17.3571M2.5 13.5V10.5" stroke="currentColor" strokeLinecap="square"/><Circle cx="18.5" cy="15.5" r="2.5" stroke="currentColor"/><Circle cx="18.5" cy="15.5" r="1.5" stroke="currentColor"/><Circle cx="18.5" cy="15.5" r="0.5" stroke="currentColor"/><Circle cx="18.5" cy="15.5" r="5" stroke="currentColor"/></CentralIconBase>;
});

export default IconScreenCapture;
